import { render, staticRenderFns } from "./popupModule.vue?vue&type=template&id=23d03f5d&scoped=true&"
import script from "./popupModule.vue?vue&type=script&lang=js&"
export * from "./popupModule.vue?vue&type=script&lang=js&"
import style0 from "./popupModule.vue?vue&type=style&index=0&id=23d03f5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d03f5d",
  null
  
)

export default component.exports